








import { Component, Prop, Vue } from 'vue-property-decorator';
import { siteConfig } from '@/SiteConfig.ts';

import AppContainerComponent from '@/components/AppContainerComponent.vue';
import HomeBannerComponent from '@/components/home/HomeBannerComponent.vue';

@Component({
  components: {
    AppContainerComponent,
    HomeBannerComponent
  }
})
export default class HomeComponent extends Vue {
  private mainText = siteConfig.mainText;
  private subText = siteConfig.subText;
  private mainTextColor = siteConfig.mainTextColor;
}
